import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "app/auth/authRoles";
import { Navigate } from "react-router-dom";

const Undertime = Loadable(lazy(() => import("./Undertime")));
const Overtime = Loadable(lazy(() => import("./Overtime")));
const Leaves = Loadable(lazy(() => import("./Leave")));

const TaskRoutes = [
  {
    path: "/task/l",
    element: <Navigate to="/task/leave" />,
    auth: authRoles.approver,
  },
  {
    path: "/task/u",
    element: <Navigate to="/task/undertime" />,
    auth: authRoles.approver,
  },
  {
    path: "/task/o",
    element: <Navigate to="/task/overtime" />,
    auth: authRoles.approver,
  },

  { path: "/task/leave", element: <Leaves />, auth: authRoles.approver },
  { path: "/task/undertime", element: <Undertime />, auth: authRoles.approver },
  { path: "/task/overtime", element: <Overtime />, auth: authRoles.approver },
];

export default TaskRoutes;
